import { useCallback, useEffect, useState } from 'react';

type UseCountdownOptions = {
  isActive?: boolean;
};

export default function useCountdown(
  initialSeconds: number,
  options: UseCountdownOptions = {}
): { timeLeft: number; reset: (nextSeconds?: number) => void } {
  const { isActive = true } = options;
  const [timeLeft, setTimeLeft] = useState<number>(initialSeconds);

  useEffect(() => {
    let intervalId: number | undefined;

    if (isActive && timeLeft > 0) {
      intervalId = window.setInterval(() => {
        setTimeLeft((prev) => Math.max(0, prev - 1));
      }, 1000);
    }

    return () => {
      if (intervalId !== undefined) {
        window.clearInterval(intervalId);
      }
    };
  }, [isActive, timeLeft]);

  const reset = useCallback(
    (nextSeconds?: number) => {
      setTimeLeft(nextSeconds ?? initialSeconds);
    },
    [initialSeconds]
  );

  return { timeLeft, reset };
}
